<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>In memoriam:</i></span></p>
<p class="ded1"><span><i>Wayde Preston, Doug McClure, John Russell, Chuck Connors and Roy Rogers</i>.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?55ee26bd